<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#ee0909" type="ball-atom" [fullScreen]="true">
  <p style="color: white"> cargando .... </p>
</ngx-spinner>

<div class="panel panel-danger">
  <div class="panel-heading ">
    <p class="encabezado">{{codigoEC}}-{{title}}</p>
  </div>
  <br> <br>
  <div class="row">
    <div class="container">
      <div class="panel-group">
        <div class="panel panel-default">
          <div class="panel-heading1  ">
            <div class="row">
              <div class="col-sm-10">
                <p class="encabezado2"><img src="./assets/images/icon/DC.png" class=" imagenE1"
                    aria-expanded="true" />&nbsp; DESCRIPCIÓN DEL ESTÁNDAR DE COMPETENCIA</p>
              </div>
              <br>
              <div class="col-sm-2">

                <a>
                  <img src="./assets/images/icon/menu-desplegable.png" class=" imagen"
                    (click)="collapseOpen('collapse1',1)" />
                </a>
              </div>
            </div>


          </div>



          <div id="collapse1" class="panel-collapse collapse ">
            <div class="panel-body">
              <div class="row">
                <div class="container">
                  <div class="col-sm-9">
                    <div class="panel ">
                      <div class="panel-heading1 ">
                        <p class="encabezado2">DESCRIPCIÓN </p>
                      </div>
                      <div class="panel-body">
                        <div class="row">
                          <div class="container">
                            <div class="col-sm-2"></div>
                            <div class="col-sm-8">
                              <br>
                              <p class="letra" style="text-justify:justify">{{desc}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br>
                    <div class="panel ">
                      <div class="panel-heading1 ">
                        <p class="encabezado2"> <img src="./assets/images/icon/Ocupaciones.png"
                            class=" imagenE1" />&nbsp;¿CUÁLES SON LAS OCUPACIONES RELACIONADAS CON EL ESTÁNDAR DE
                          COMPETENCIA? </p>
                      </div>
                      <div class="panel-body">
                        <div class="row">
                          <div class="container">
                            <div class="col-sm-2"></div>
                            <div class="col-sm-8">
                              <br>
                              <table mat-table [dataSource]="dataSource"
                                class="tableGenerales table table-striped table-bordered">
                                <ng-container matColumnDef="ocupaciones">
                                  <th mat-header-cell *matHeaderCellDef>Ocupaciones</th>
                                  <td mat-cell *matCellDef="let element">{{element.nombre}} </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="panel ">
                      <div class="panel-heading1 ">
                        <p class="encabezado2" style="text-align: center;">ENLACES</p>
                      </div>
                      <div class="panel-body">
                        <div class="row">
                          <div class="container">
                            <div class="col-sm-3"></div>
                            <div class="col-sm-1">
                              <a (click)="getFichaEstandar(idEstandar)"><img src="./assets/images/pdf.jpg"
                                  class=" imagenE" /></a>
                            </div>
                            <div class="col-sm-2">
                              <p class="letraE" style="text-align: center;">&nbsp;Conoce el Estándar de Competencia.</p>
                            </div>
                            <div class="col-sm-1">
                              <a href="https://www.dof.gob.mx/" target="_blank"><img src="./assets/images/diario.png"
                                  class=" imagenE" /></a>
                            </div>
                            <div class="col-sm-2">
                              <p class="letraE" style="text-align: center;">&nbsp;Fecha de Publicación DOF: </p>
                              <p class="letraE" style="text-align: center;">{{fecPublicacion}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="container">
      <div class="panel-group">
        <div class="panel panel-default">
          <div class="panel-heading1  ">
            <div class="row">
              <div class="col-sm-10">
                <p class="encabezado2"> <img src="./assets/images/icon/EC.png" class=" imagenE1" />&nbsp;¿PARA QUÉ ME
                  SIRVE Y CÓMO PUEDO CERTIFICARME?</p>
              </div>
              <br>
              <div class="col-sm-2">
                <a>
                  <img src="./assets/images/icon/menu-desplegable.png" class=" imagen"
                    (click)="collapseOpen('collapse2',2)" />
                </a>
              </div>
            </div>
          </div>
          <div id="collapse2" class="panel-collapse collapse">
            <div class="panel-body">
              <div class="row">
                <div class="container">
                  <div class="col-sm-2"></div>
                  <div class="col-sm-9">
                    <br>
                    <p class="letra" style="text-align: justify;">Al certificarte estás contribuyendo a mejorar tu
                      desarrollo personal y profesional: te conviertes en un trabajador con mayores oportunidades para
                      competir en un mercado laboral exigente y complejo pues cada día son más las empresas de nuestro
                      país que requieren trabajadores con experiencias, saberes, habilidades y destrezas certificadas,
                      capaces de cumplir exitosamente con las funciones que se les encomienda.</p>
                    <br>
                    <p class="letra" style="text-align: justify;">Un Certificado de Competencia reconoce el saber hacer
                      de una persona independientemente de la forma en que se haya adquirido el saber, el saber hacer y
                      el ser. El Certificado de Competencia es un documento oficial donde se acredita a una persona como
                      competente de acuerdo a lo establecido en un Estándar de Competencia, y se encuentra en el
                      Registro Nacional de Estándares de competencia.</p>
                    <br>
                    <p style="text-align: center;"><strong>¿QUIERES CONOCER MÁS SOBRE LAS CERTIFICACIONES?</strong></p>



                    <!--p style="text-align: center;color:blue" (click)="ifram()"><strong>[GUIA DE CERTIFICACIÓN]</strong></p-->
                    <!--guiaCertificacion *ngIf="iframe"></guiaCertificacion-->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="container">
                  <div class="col-sm-4"></div>
                  <div class="col-sm-5">

                    <p style="font-style: italic;text-align: center;"><Strong>Pulsa sobre la imagen del folleto o en el
                        siguiente link</Strong></p>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="container">
                  <div class="col-sm-6"></div>
                  <div class="col-sm-2">

                    <a style="text-align: center;" href="https://conocer.gob.mx/certifico-mis-competencias/"
                      target="_blank">
                      <img src="./assets/images/icon/certificado.png" class=" imagenE" />
                    </a>

                  </div>
                </div>
              </div>

            </div>
            <div class="panel-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="container">
      <div class="panel-group">
        <div class="panel panel-default">
          <div class="panel-heading1  ">
            <div class="row">
              <div class="col-sm-10">
                <p class="encabezado2"> <img src="./assets/images/icon/Donde.png" class=" imagenE1" />&nbsp;¿EN DÓNDE
                  PUEDO CERTIFICARME?</p>
              </div>
              <br>
              <div class="col-sm-2">
                <a>
                  <img src="./assets/images/icon/menu-desplegable.png" class=" imagen"
                    (click)="collapseOpen('collapse3',3)" />
                </a>
              </div>
            </div>
          </div>
          <div id="collapse3" class="panel-collapse collapse">
            <div class="panel-body">
              <div class="row">
                <div class="container">
                  <div class="col-sm-4 ">
                    <div class="example-container">
                      <table mat-table [dataSource]="dataSource2"
                        class="tableGenerales table table-striped table-bordered">
                        <ng-container matColumnDef="razonSocial">
                          <th mat-header-cell *matHeaderCellDef>Certificadores Acreditados</th>
                          <td mat-cell *matCellDef="let element" (click)="getDatos(element.clAcreditacionEce)">
                            {{element.razonSocial}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>

                      </table>
                      <div style="text-align: center;" class="encabezado2" *ngIf="mostrarCertificadores">No
                        Cuenta con Entidades
                        Certificadoras</div>
                    </div>
                  </div>
                  <div class="col-sm-1"></div>
                  <div class="col-sm-7" id="descr" *ngIf="col">
                    <div class="panel-heading1 ">
                      <p class="encabezado2"> Datos </p>
                    </div>
                    <div class="panel-body ">
                      <table class="table">
                        <tr>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Clave: </p>
                          </td>
                          <td>{{clave}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Razón Social: </p>
                          </td>
                          <td>{{razonSocial}}</td>
                        </tr>

                        <tr>
                          <td>
                            <p class="letraE">Siglas: </p>
                          </td>
                          <td>{{siglas}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Fecha: </p>
                          </td>
                          <td>{{fechaCon}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Calle: </p>
                          </td>
                          <td>{{calleNumero}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Colonia: </p>
                          </td>
                          <td>{{colonia}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Delegación/Municipio: </p>
                          </td>
                          <td>{{localidad}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Entidad Federativa: </p>
                          </td>
                          <td>{{entidadFederativa}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Código Postal: </p>
                          </td>
                          <td>{{codigoPostal}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Teléfonos: </p>
                          </td>
                          <td>{{telefono}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Fax: </p>
                          </td>
                          <td>{{fax}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Sitio Web: </p>
                          </td>
                          <td>{{sitio}}</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="letraE">Correo Electronico: </p>
                          </td>
                          <td>{{correo}}</td>
                        </tr>
                      </table>

                    </div>


                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br>

  <div class="row">
    <div class="container">
      <div class="panel-group">
        <div class="panel panel-default">
          <div class="panel-heading1  ">
            <div class="row">
              <div class="col-sm-10">
                <p class="encabezado2"><img src="./assets/images/icon/junta.png" class=" imagenE1" />&nbsp;COMITÉ DE
                  GESTIÓN POR COMPETENCIAS
                  QUE LO DESARROLLÓ</p>
              </div>
              <br>
              <div class="col-sm-2">
                <a>
                  <img src="./assets/images/icon/menu-desplegable.png" class=" imagen"
                    (click)="collapseOpen('collapse4',4)" />
                </a>
              </div>
            </div>
          </div>
          <div id="collapse4" class="panel-collapse collapse">
            <div class="panel-body">
              <div class="row">
                <div class="container">
                  <div class="col-sm-6">
                    <div class="panel-heading1 ">
                      <p class="encabezado2">¿QUIÉN INTEGRA EL COMITÉ DE GESTIÓN POR COMPETENCIAS? </p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="panel-heading1 ">
                      <p class="encabezado2">CONTACTO </p>
                    </div>
                  </div>

                </div>
              </div>
              <div class="row">
                <div class="container">
                  <div class="col-sm-4 example-container">
                    <table mat-table [dataSource]="dataSource3"
                      class="tableGenerales table table-striped table-bordered ">
                      <ng-container matColumnDef="integrantes">
                        <th mat-header-cell *matHeaderCellDef>Integrantes</th>
                        <td mat-cell *matCellDef="let element">{{element.nombre}} </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns3;"></tr>

                    </table>

                  </div>

                  <div class="col-sm-1"></div>
                  <div class="col-sm-7">
                    <div class="panel-body ">
                      <table class="table">
                        <tr>
                          <th colspan="2" style="text-align: left;">
                            <h4> <Strong> Comité </Strong></h4>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Presidente: </p>
                          </th>
                          <th>
                            <p class="letraE">{{presidente}} </p>
                          </th>

                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Puesto: </p>
                          </th>
                          <th>
                            <p class="letraE">{{puestoPresidente}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Vicepresidente: </p>
                          </th>
                          <th>
                            <p class="letraE">{{vicepresidente}}</p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Puesto: </p>
                          </th>
                          <th>
                            <p class="letraE">{{puestoVicepresidente}} </p>
                          </th>
                        </tr>


                      </table>
                      <table class="table">
                        <tr>
                          <th colspan="2" style="text-align: left;">
                            <h4> <Strong> Datos Contacto </Strong></h4>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Contacto</p>
                          </th>
                          <th>
                            <p class="letraE">{{contacto}} </p>
                          </th>

                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Calle y Número: </p>
                          </th>
                          <th>
                            <p class="letraE">{{calleNumeroC}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Colonia</p>
                          </th>
                          <th>
                            <p class="letraE">{{coloniaC}}</p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Localidad: </p>
                          </th>
                          <th>
                            <p class="letraE">{{localidadC}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Delegación: </p>
                          </th>
                          <th>
                            <p class="letraE">{{delegacionC}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Entidad Federativa: </p>
                          </th>
                          <th>
                            <p class="letraE">{{entidadFederativaC}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Teléfono: </p>
                          </th>
                          <th>
                            <p class="letraE">{{telefonoC}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">E-mail: </p>
                          </th>
                          <th>
                            <p class="letraE">{{correoC}} </p>
                          </th>
                        </tr>
                      </table>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <br>

  <div class="row" *ngIf="mostrarCursos">
    <div class="container">
      <div class="panel-group">
        <div class="panel panel-default">
          <div class="panel-heading1  ">
            <div class="row">
              <div class="col-sm-10">
                <p class="encabezado2"> <img src="./assets/images/icon/Ocupaciones.png" class=" imagenE1" />&nbsp;¿EN
                  DÓNDE
                  PUEDO CAPACITARME?</p>
              </div>
              <br>
              <div class="col-sm-2">
                <a>
                  <img src="./assets/images/icon/menu-desplegable.png" class=" imagen"
                    (click)="collapseOpen('collapse5',5)" />
                </a>
              </div>
            </div>
          </div>
          <div id="collapse5" class="panel-collapse collapse">
            <div class="panel-body">
              <div class="row">
                <div class="container">
                  <div class="col-sm-4 ">
                    <div class="example-container">
                      <table mat-table [dataSource]="dataSource4"
                        class="tableGenerales table table-striped table-bordered">
                        <ng-container matColumnDef="cursos">
                          <th mat-header-cell *matHeaderCellDef>Cursos</th>
                          <td mat-cell *matCellDef="let element" (click)="getDatosCurso(element.idCurso)">
                            {{element.nombreCurso}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns4"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns4;"></tr>
                      </table>
                    </div>
                  </div>

                  <div class="col-sm-1"></div>
                  <div class="col-sm-7" *ngIf="col2">
                    <div class="panel-body ">
                      <table class="table">
                        <tr>
                          <th colspan="2" style="text-align: left;">
                            <h4> <Strong> Estándar de Competencia en que se basa el curso de capacitación </Strong></h4>
                          </th>
                        </tr>
                        <tr>
                          <th colspan="2" style="text-align: left;">
                            <h4> <Strong>{{nombreCurso}} </Strong></h4>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Descripción/Objetivo:&nbsp;&nbsp;</p>
                          </th>
                          <th>
                            <p class="letra" style="text-justify:justify">{{objetivo}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Módulos:</p>
                          </th>
                          <th>
                            <p class="letra" style="text-justify:justify">{{modulos}}</p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Modalidad:</p>
                          </th>
                          <th>
                            <p class="letraE">{{modalidad}}</p>
                          </th>
                        </tr>
                      </table>
                      <table class="table">
                        <tr>
                          <th colspan="2" style="text-align: left;">
                            <h4> <Strong> Datos del Capacitador </Strong></h4>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Nombre:</p>
                          </th>
                          <th>
                            <p class="letraE">{{nombreCap}} </p>
                          </th>

                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Calle y Número: </p>
                          </th>
                          <th>
                            <p class="letraE">{{calleCap}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Colonia</p>
                          </th>
                          <th>
                            <p class="letraE">{{coloniaCap}}</p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Localidad: </p>
                          </th>
                          <th>
                            <p class="letraE">{{localidadCap}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Entidad Federativa: </p>
                          </th>
                          <th>
                            <p class="letraE">{{entidadFedCap}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Municipio: </p>
                          </th>
                          <th>
                            <p class="letraE">{{municipioCap}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Código Postal: </p>
                          </th>
                          <th>
                            <p class="letraE">{{cpCap}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Teléfonos: </p>
                          </th>
                          <th>
                            <p class="letraE">{{telefonoCap}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Página Web: </p>
                          </th>
                          <th>
                            <p class="letraE">{{paginaWebCap}} </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Correo Electrónico: </p>
                          </th>
                          <th>
                            <p class="letraE">{{mail}} </p>
                          </th>
                        </tr>
                      </table>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br>

  <div class="row">
    <div class="container">
      <div class="col-sm-5"></div>
      <div style="text-align: center;" class="col-sm-1">
        <button mat-button (click)="back()"><img src="./assets/images/icon/Atras.png" class=" imagen" /></button>
      </div>
      <div style="text-align: center;" class="col-sm-1">
        <button mat-button (click)="home()"><img src="./assets/images/icon/Home.png" class=" imagen" /></button>
      </div>
    </div>
  </div>
</div>